import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";


class PrivateMyAdvertisementsState {
    constructor(
        myAdvertisementsLoadingState,
        openAdvertisements,
        closedAdvertisements
    ) {
        this.myAdvertisementsLoadingState = myAdvertisementsLoadingState;
        this.openAdvertisements = openAdvertisements;
        this.closedAdvertisements = closedAdvertisements;
    }

    equals(other) {
        return this.myAdvertisementsLoadingState === other.myAdvertisementsLoadingState &&
            this.openAdvertisements === other.openAdvertisements &&
            this.closedAdvertisements === other.closedAdvertisements;

    }
}

class ImmutableMyAdvertisementsStateBuilder {

    constructor() {
        this.myAdvertisementsLoadingState = LoadingStates.INITIALIZED;
        this.openAdvertisements = [];
        this.closedAdvertisements = [];
    }

    setFromState(state) {
        return this.setMyAdvertisementsLoadingState(state.myAdvertisementsLoadingState)
            .setOpenAdvertisements(state.openAdvertisements)
            .setClosedAdvertisements(state.closedAdvertisements);
    }

    setMyAdvertisementsLoadingState(loadingState) {
        this.myAdvertisementsLoadingState = loadingState;
        return this;
    }

    setOpenAdvertisements(spaces) {
        this.openAdvertisements = spaces;
        return this;
    }

    setClosedAdvertisements(spaces) {
        this.closedAdvertisements = spaces;
        return this;
    }

    build() {
        return Object.freeze(
            new PrivateMyAdvertisementsState(
                this.myAdvertisementsLoadingState,
                this.openAdvertisements,
                this.closedAdvertisements));
    }
}


class PrivateMyAdvertisementsStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.PRIVATE_MY_ADVERTISEMENTS_STORE_UPDATE, ImmutableMyAdvertisementsStateBuilder);
        this.subscribeToEvent(ActionResultEvents.MY_ADVERTISEMENTS_LOADED, this.handleMyAdvertisementLoaded);
        this.subscribeToEvent(UIInteractionEvents.GET_MY_ADVERTISEMENTS, this.handleMyAdvertisementsLoading);
        this.subscribeToEvent(UIInteractionEvents.PRIVATE_SPACE_DETAILS_SET_SPACE_ID, this.handleMyAdvertisementsLoading);
        this.subscribeToEvent(UIInteractionEvents.MY_ADVERTISEMENTS_UNMOUNTED, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.OPEN_ADVERTISEMENT_CLICKED, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.CLOSE_ADVERTISEMENT_CLICKED, this.resetStore);
    }

    handleMyAdvertisementsLoading = (topic, data) => {
        return new ImmutableMyAdvertisementsStateBuilder()
            .setFromState(this.state)
            .setMyAdvertisementsLoadingState(LoadingStates.LOADING)
            .build();
    };

    handleMyAdvertisementLoaded = (topic, data) => {
        return new ImmutableMyAdvertisementsStateBuilder()
            .setFromState(this.state)
            .setMyAdvertisementsLoadingState(LoadingStates.FINISHED_LOADING)
            .setClosedAdvertisements(data.closedAdvertisements)
            .setOpenAdvertisements(data.openAdvertisements)
            .build();
    };

}

export default new PrivateMyAdvertisementsStore();